import {request} from "../request/request";

const reserve = {
  create: (data) => request.create('/reserve', data),
};

export {reserve};